module.exports = __webpack_public_path__ + "static/img/al7.10eccd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al7.jpg
// module id = dtQg
// module chunks = 0